import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const features = ['Plus de 100 projets de robots', 'Matériaux simples du quotidien', 'Guides PDF pas à pas', 'Aucune expérience nécessaire', 'Idéal de 4 à 12 ans', 'Téléchargement numérique instantané'];
const floatingBadges = [{
  label: '🤖 Construisez de vrais robots',
  pos: 'left-4 top-4 sm:-left-4',
  tone: 'bg-sky-light'
}, {
  label: '🧠 Développe les compétences STEM',
  pos: 'right-4 top-16 sm:-right-6',
  tone: 'bg-sunshine-light'
}, {
  label: '📄 Guides PDF',
  pos: 'left-4 bottom-24 sm:-left-6',
  tone: 'bg-mint-light'
}, {
  label: '📦 Plus de 100 projets',
  pos: 'right-4 bottom-6 sm:-right-4',
  tone: 'bg-coral-light'
}];
const avatars = [{
  letter: 'J',
  color: 'bg-brand'
}, {
  letter: 'S',
  color: 'bg-emerald-500'
}, {
  letter: 'M',
  color: 'bg-blue-500'
}, {
  letter: 'R',
  color: 'bg-amber-500'
}];
export function Hero() {
  return <section className="w-full overflow-hidden bg-cream" data-id="element-68" data-mp="3o7vj9hzbpjw8">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 py-14 sm:px-6 md:py-20 lg:grid-cols-2 lg:gap-16" data-id="element-69" data-mp="3o59e1ozwngh6">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-70" data-mp="3e961rqbca1gi">
          <p className="mb-5 flex items-center gap-3 text-sm font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-71" data-mp="35akmc415z2jy">
            <span className="h-px w-8 bg-brand" aria-hidden="true" data-id="element-72" data-mp="2viomoojfj4dm" />
            Plus de 100 projets de robots pour enfants
          </p>
          <h1 className="font-display text-4xl font-black leading-[1.05] text-ink sm:text-5xl md:text-6xl" data-id="element-73" data-mp="2hk87sabey7ke">
            Éloignez vos enfants{' '}
            <span className="italic text-brand" data-id="element-74" data-mp="2lml8ulf7thau">des écrans</span> — grâce à
            la robotique !
          </h1>
          <p className="mt-6 max-w-lg text-lg leading-relaxed text-ink/60" data-id="element-75" data-mp="nbl4urpxgsdm">
            Du plaisir qui{' '}
            <strong className="text-ink" data-id="element-76" data-mp="iboyiltrcouw">apprend vraiment quelque chose</strong>.
            Avec des matériaux simples du quotidien et des guides PDF pas à pas, votre
            enfant apprend, joue et grandit — loin des écrans.
          </p>

          <div className="mt-8 flex items-center gap-4" data-id="element-77" data-mp="1b0duk6fyi3zs">
            <div className="flex -space-x-2" data-id="element-78" data-mp="161aul0eu2nyo">
              {avatars.map(a => <span key={a.letter} className={`flex h-9 w-9 items-center justify-center rounded-full border-2 border-cream text-sm font-bold text-white ${a.color}`} data-id="element-79" data-mp="112g6biy3k776">
                  {a.letter}
                </span>)}
            </div>
            <div data-id="element-80" data-mp="3hqu269afm60n">
              <div className="flex text-amber-400" aria-hidden="true" data-id="element-81" data-mp="3hqaj2p91pbl1">
                {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-82" data-mp="21amwtbz2vwne" data-mpi={i} />)}
              </div>
              <p className="text-sm text-ink/60" data-id="element-83" data-mp="26a96jbfp6urg">
                <strong className="text-ink" data-id="element-84" data-mp="268oeptkrppxa">Plus de 2 000 familles</strong> construisent déjà
                ensemble
              </p>
            </div>
          </div>

          <ul className="mt-8 grid gap-x-6 gap-y-3 sm:grid-cols-2" data-id="element-85" data-mp="2fyr5ro8bwtsz">
            {features.map(f => <li key={f} className="flex items-center gap-2.5 text-sm font-semibold text-ink" data-id="element-86" data-mp="2kxu8v34r0pyb">
                <span className="flex h-5 w-5 flex-none items-center justify-center rounded-full bg-brand-light text-brand" data-id="element-87" data-mp="2oyo0a6hegmvy">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-88" data-mp="umzhft81s06a" />
                </span>
                {f}
              </li>)}
          </ul>

          <div className="mt-10" data-id="element-89" data-mp="znn82dsd6ezz">
            <CtaButton data-id="element-90" data-mp="4aurcylqfdrh">Oui ! Je veux MakerLab</CtaButton>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15,
        ease: 'easeOut'
      }} className="relative mx-auto w-full max-w-md lg:max-w-none" data-id="element-91" data-mp="3vhxgzllx9bzl">
          <div className="relative overflow-hidden rounded-[2rem] bg-white shadow-2xl" data-id="element-92" data-mp="3hnxrgcgru6og">
            <img src="https://cdn.magicpatterns.com/uploads/w797rNVFktSefVq8gWTeqy/ChatGPT_Image_3_jul_2026,_12_52_06_p.m..png" alt="Couverture MakerLab montrant un joyeux robot en carton et des icônes colorées de projets STEM" className="aspect-[4/3] w-full object-contain" data-id="element-93" data-mp="3cp336v01bpwy" />
          </div>
          {floatingBadges.map(b => <motion.div key={b.label} initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          delay: 0.5
        }} className={`absolute rounded-full px-3.5 py-2 text-xs font-bold text-ink shadow-lg ${b.pos} ${b.tone}`} data-id="element-94" data-mp="2u0fywepon4kf">
              {b.label}
            </motion.div>)}
        </motion.div>
      </div>
      <div className="h-2 w-full bg-brand" aria-hidden="true" data-id="element-95" data-mp="1x8ht4ci7c3gp" />
    </section>;
}